// extracted by mini-css-extract-plugin
export default {"copy_button":"GroceryListTitle_copy_button__YrjyF"};